import React, { Component, useState } from "react";
import * as Yup from "yup";
import { useAlert } from "../context/AlertContext";
import { useLoading } from "context/LoadingContext";
import { resetPasswordApi } from "../Service/ApiService";
import { useNavigate, useLocation } from "react-router-dom";

// Validation
const schema = Yup.object().shape({
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters"),

  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
});

const ResetPasswordController = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  const navigate = useNavigate();
  const location = useLocation();

  const { vendorCode } = location.state || {};

  // Validate individual field on change
  const validateField = async (fieldName, value) => {
    try {
      await Yup.reach(schema, fieldName).validate(value);
      setErrors((prev) => ({ ...prev, [fieldName]: null }));
    } catch (err) {
      setErrors((prev) => ({ ...prev, [fieldName]: err.message }));
    }
  };

  // Set Password
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);

    validateField("password", e.target.value);
  };

  // Set Password Cinfirm
  const handleConfirmPasswordChange = async (e) => {
    const value = e.target.value;
    setConfirmPassword(value);

    try {
      await schema.validate({ password, confirmPassword: value }, { abortEarly: false });
      setErrors((prev) => ({ ...prev, confirmPassword: null }));
    } catch (err) {
      const confirmError = err.inner.find((e) => e.path === "confirmPassword");
      setErrors((prev) => ({
        ...prev,
        confirmPassword: confirmError ? confirmError.message : null,
      }));
    }
  };

  // Reset Password
  const handleResetPassword = async () => {
    try {
      await schema.validate({ password, confirmPassword }, { abortEarly: false });
      setLoading(true);
      const response = await resetPasswordApi(vendorCode, password);
      if (response.success) {
        showAlert(response.msg, {
          icon: "success",
          title: "Success",
        });
        navigate("/login");
      } else {
        showAlert(response.msg);
      }
    } catch (error) {
      showAlert("Please fill valid inputs!");
    } finally {
      setLoading(false);
    }
  };

  return {
    password,
    confirmPassword,
    errors,
    handlePasswordChange,
    handleConfirmPasswordChange,
    handleResetPassword,
  };
};

export default ResetPasswordController;
